// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1PlQU","left":"InfoRow_left__onNf_"};